(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('WikiController', WikiController);

    WikiController.$inject = ['$scope', '$state', 'Wiki', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'Alerta'];

    function WikiController($scope, $state, Wiki, ParseLinks, AlertService, paginationConstants, pagingParams, Alerta) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.loadWiki = loadWiki;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.remover = remover;
        vm.itemsPerPage = 999;
        vm.wikis;
        vm.filtro = " ";

        function loadAll() {
            Wiki.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                filtro: vm.filtro
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(dwiki) {
                vm.wikis = dwiki;
                if(vm.wikis && vm.wikis.length){
                    loadWiki(vm.wikis[0].id);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        vm.loadAll();

        function loadWiki(id) {
            Wiki.get({id: id}, function (data) {
                vm.wiki = data;
            })
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function remover(id) {
            Alerta.confirm("Atenção", "Tem certeza que deseja remover essa Wiki?", "warning", function () {
                Wiki.delete({id: id},
                    function () {
                        Alerta.success("Operação realizada", "O Wiki foi removida!");
                        vm.loadAll();
                        $scope.$emit('chamadosApp:wikiUpdate');

                    });
            });
        }
    }
})();
